import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const CACHE_PREFIX = "iacover_cache:";

// GET avec repli hors-ligne : met en cache la réponse et la ressert si le réseau est indisponible.
export async function cachedGet(path) {
  const key = CACHE_PREFIX + path;
  try {
    const res = await api.get(path);
    try {
      localStorage.setItem(key, JSON.stringify(res.data));
    } catch {
      /* quota */
    }
    return { data: res.data, offline: false };
  } catch (e) {
    if (!e.response) {
      const raw = localStorage.getItem(key);
      if (raw != null) {
        try {
          return { data: JSON.parse(raw), offline: true };
        } catch {
          /* corrupted cache */
        }
      }
    }
    throw e;
  }
}

// Purge le cache local (données + session) — appelé à la déconnexion.
export function clearApiCache() {
  try {
    Object.keys(localStorage).forEach((k) => {
      if (k.startsWith(CACHE_PREFIX) || k === "iacover_user") localStorage.removeItem(k);
    });
  } catch {
    /* ignore */
  }
}

export default api;
